module.exports = __webpack_public_path__ + "static/media/CTARight.b8bf3ab6.svg";